module.exports = __webpack_public_path__ + "media/ביס.ebc26323.mp3";